// import React, { useContext, useEffect, useRef, useState } from 'react';
// import { DContext } from '../../context/Datacontext';
// import { fetchJob } from '../services/fetchJob';
// import { useNavigate, useSearchParams } from 'react-router-dom';
// import { FaRegEdit } from "react-icons/fa";
// import { MdOutlineDeleteOutline } from "react-icons/md";
// import { FaEye } from "react-icons/fa";
// // import Pagination from './Pagination';
// import { reassignJob, updateJob } from '../services/updateJob';
// import { HiUserAdd } from "react-icons/hi";
// import { IoPeopleSharp } from "react-icons/io5";
// import Loading from './Loading';
// import { renderCapitalize } from '../../utils/renderCapitalize';

// export const JobList = () => {
//     const { BeURL, showAlert, currentUser } = useContext(DContext);
//     const [allJobs, setAllJobs] = useState([]);
//     const [filteredJobs, setFilteredJobs] = useState([]);
//     const [loading, setLoading] = useState(true);
//     const [searchKeyword, setSearchKeyword] = useState('');
//     const [triggerSearch, setTriggerSearch] = useState(false);
//     const [triggerReassign, setTriggerReassign] = useState(false)

//     // Duration and date filters
//     const [activeIndex, setActiveIndex] = useState('All')
//     const [fromDate, setFromDate] = useState('')
//     const [toDate, setToDate] = useState('')

//     // Same Pagination after click the CTA Buttons
//     const [searchParams, setSearchParams] = useSearchParams();
//     const [currentPage, setCurrentPage] = useState(
//         Number(searchParams.get("page")) || 1
//     );

//     const [rowsPerPage, setRowsPerPage] = useState(10);
//     const [totalPage, setTotalPage] = useState(0);
//     const [total, setTotal] = useState(0);
//     // const [perPageTotal, setPerPageTotal] = useState(0)

//     const apiRef = useRef()

//     const filterButton = [
//         { label: 'All', title: 'All' },
//         { label: 'Today', title: 'Today' },
//         { label: 'YesterDay', title: 'YesterDay' },
//         { label: '1W', title: 'This Week' },
//         { label: '1M', title: 'This Month' },
//         { label: '3M', title: 'Last 3-Month' },
//         { label: '6M', title: 'Last 6-Month' },
//         { label: '1Y', title: 'This Year' }
//     ]

//     const navigate = useNavigate();
//     // useEffect(() => {
//     //     localStorage.removeItem('currentPage');
//     // }, []);


//     const getJobs = async () => {

//         if (apiRef.current) return;    // PREVENT DUPLICATES
//         apiRef.current = true;
//         setLoading(true);


//         try {
//             await fetchJob(BeURL, setAllJobs, showAlert, currentPage, rowsPerPage, setTotal, setTotalPage, activeIndex, fromDate, toDate, searchKeyword);
//         } catch (err) {
//             console.error("Error fetching jobs:", err);
//         } finally {
//             apiRef.current = false;
//             setLoading(false);
//         }
//     };

//     useEffect(() => {

//         getJobs();
//         // eslint-disable-next-line react-hooks/exhaustive-deps
//     }, [BeURL, currentPage, rowsPerPage, activeIndex, fromDate, toDate, triggerSearch, triggerReassign])


//     useEffect(() => {
//         const page = Number(searchParams.get("page")) || 1;
//         setCurrentPage(page);
//     }, [searchParams]);

//     // useEffect(() => {

//     //     getJobs();
//     // }, []);

//     // filter button date range clear
//     useEffect(() => {
//         if (fromDate || toDate) {
//             setActiveIndex("");
//         }
//     }, [fromDate, toDate]);

//     const handleRequirement = (label) => {
//         setFromDate('')
//         setToDate('')
//         setActiveIndex(label)
//     }

//     const handleDelete = (id) => {
//         if (window.confirm("Are you sure you want to delete this job?")) {
//             updateJob(BeURL, null, showAlert, null, id, { access: 'delete' });
//         }
//     };

//     // const handlePagination = (dir) => {
//     //     if (dir === "prev" && currentPage > 1) setCurrentPage((p) => p - 1);
//     //     if (dir === "next" && currentPage < totalPage) setCurrentPage((p) => p + 1);
//     // };

//     const handlePagination = (dir) => {

//         let newPage = currentPage;

//         if (dir === "prev" && currentPage > 1) {
//             newPage = currentPage - 1;
//         }

//         if (dir === "next" && currentPage < totalPage) {
//             newPage = currentPage + 1;
//         }

//         setCurrentPage(newPage);
//         setSearchParams({ page: newPage, search: searchKeyword });
//     };

//     // const handleSearch = () => {
//     //     // const keyword = searchKeyword.toLowerCase().trim();

//     //     // const filtered = allJobs.filter(job => {
//     //     //     const title = job.title?.toLowerCase() || "";
//     //     //     const jobId = job.jobId?.toLowerCase() || "";
//     //     //     const vacancies = job.vacancies?.toString().toLowerCase() || "";   // number → string
//     //     //     const jobStatus = job.jobStatus?.toLowerCase() || "";
//     //     //     const updatedAt = job.updatedAt
//     //     //         ? new Date(job.updatedAt).toLocaleDateString().toLowerCase()   // date → formatted string
//     //     //         : "";

//     //     //     return (
//     //     //         title.includes(keyword) ||
//     //     //         jobId.includes(keyword) ||
//     //     //         vacancies.includes(keyword) ||
//     //     //         jobStatus.includes(keyword) ||
//     //     //         updatedAt.includes(keyword)
//     //     //     );
//     //     // });

//     //     // setFilteredJobs(filtered);
//     //     getJobs();
//     // };

// const handleSearch = () => {
//     setSearchParams({
//         page: 1,
//         search: searchKeyword
//     });

//     setCurrentPage(1);
//     setTriggerSearch(prev => !prev);
// };

//     useEffect(() => {
//         const keyword = searchParams.get("search") || '';
//         setSearchKeyword(keyword);
//     }, [searchParams]);



//     const handleClearSearch = () => {
//         setSearchKeyword('');
//         setFilteredJobs([]);
//         setActiveIndex('All');
//         setFromDate('');
//         setToDate('');
//         setCurrentPage(1);
//         setSearchParams({ page: 1 }); // search param remove
//         setTriggerSearch(prev => !prev);
//     };

//     const displayJobs = filteredJobs.length > 0 ? filteredJobs : allJobs;

//     // Access control for Edit button
//     const getAccess = (job) => {
//         if (job.primaryRecruiter?.email === currentUser?.email) return true;
//         if (job.reportingTeamLead?.email === currentUser?.email) return true;
//         if (job.reportingManager?.email === currentUser?.email) return true;
//         if (['admin'].includes(currentUser?.role)) return true;
//         return false;
//     }


//     //  handle for Job reassign

//     const handleReassign = async (jobObjId, jobId, isChecked, event) => {

//         const isConfirmed = window.confirm("Are you sure you want to reassign this job?");

//         if (!isConfirmed) {
//             event.target.checked = !isChecked;
//             return;
//         }
//         setTriggerReassign(true)
//         const payload = {
//             jobId: jobId,
//             isreassign: isChecked
//         };

//         await reassignJob(BeURL, showAlert, jobObjId, payload);
//     };

//     useEffect(()=>{

//     },[])

//     if (loading) return <Loading />;

//     return (
//         <div className='min-h-[80vh] space-y-4 mt-3 px-4 md:px-10'>
//             <h2 className="text-2xl font-semibold mb-4 text-gray-800 text-center">All Jobs</h2>

//             <div className='bg-gradient-to-br from-white to-slate-50/50 rounded-2xl shadow-lg border border-slate-200/60 p-4 mb-6'>
//                 <div className='flex flex-col gap-3'>

//                     {/* Time Filter Buttons & Date Range */}
//                     <div className="space-y-3 flex flex-col md:flex-row md:justify-between md:items-center flex-wrap ">
//                         {/* Quick Filter Buttons */}
//                         <div className='flex items-center gap-2 flex-wrap'>
//                             <div className='flex items-center gap-1.5'>
//                                 {/* <div className='w-1 h-5 bg-gradient-to-b from-secondary-400 to-secondary-600 rounded-full'></div> */}
//                                 <h3 className='text-xs font-bold text-slate-700 uppercase tracking-wide'>Quick Filters</h3>
//                             </div>
//                             <div className="flex gap-2 flex-wrap">
//                                 {filterButton.map((btn, i) => (
//                                     <button
//                                         key={i}
//                                         title={btn.title}
//                                         className={`relative px-3 py-1.5 font-semibold text-xs rounded-lg transition-all duration-300 transform hover:scale-105 hover:shadow-md
//                                      ${activeIndex === btn.label
//                                                 ? "bg-gradient-to-r from-secondary-400 to-secondary-600 text-white shadow-lg shadow-secondary-200/50 scale-105"
//                                                 : "bg-white text-secondary-500 border-[1px] border-secondary-100 hover:border-secondary-400 hover:bg-secondary-700"
//                                             }
//                                         ${activeIndex === btn.label ? 'ring-[1px] ring-secondary-200 ring-offset-1' : ''}`}
//                                         onClick={() => handleRequirement(btn.label)}
//                                     >
//                                         {activeIndex === btn.label && (
//                                             <span className="absolute -top-0.5 -right-0.5 flex h-2 w-2">
//                                                 <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-white opacity-75"></span>
//                                                 <span className="relative inline-flex rounded-full h-2 w-2 bg-white"></span>
//                                             </span>
//                                         )}
//                                         {btn.label}
//                                     </button>
//                                 ))}
//                             </div>
//                         </div>

//                         {/* Date Range Picker */}
//                         <div className='flex items-center gap-2 flex-wrap'>
//                             <div className='flex items-center gap-1.5'>
//                                 {/* <div className='w-1 h-5 bg-gradient-to-b from-purple-400 to-purple-600 rounded-full'></div> */}
//                                 <h3 className='text-xs font-bold text-slate-700 uppercase tracking-wide'>Custom Range</h3>
//                             </div>
//                             <div className='flex gap-2 items-center flex-wrap'>
//                                 <div className='group relative'>
//                                     <label className='text-xs font-semibold text-slate-600 mb-0.5 block'>From Date</label>
//                                     <div className='relative'>
//                                         <input
//                                             type='date'
//                                             value={fromDate}
//                                             onChange={(e) => setFromDate(e.target.value)}
//                                             className='pl-3 pr-2 py-1.5 border-2 border-slate-200 rounded-lg text-xs font-medium text-slate-700 bg-white hover:border-purple-300 focus:border-purple-400 focus:ring-2 focus:ring-purple-100 transition-all outline-none w-full sm:w-auto'
//                                         />
//                                         <div className='absolute inset-0 rounded-lg bg-gradient-to-r from-purple-400/0 to-purple-400/0 group-hover:from-purple-400/5 group-hover:to-transparent pointer-events-none transition-all'></div>
//                                     </div>
//                                 </div>
//                                 <div className='hidden sm:flex items-center pt-5'>
//                                     <svg className='w-5 h-5 text-slate-400' fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                                         <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
//                                     </svg>
//                                 </div>
//                                 <div className='group relative'>
//                                     <label className='text-xs font-semibold text-slate-600 mb-0.5 block'>To Date</label>
//                                     <div className='relative'>
//                                         <input
//                                             type='date'
//                                             value={toDate}
//                                             onChange={(e) => setToDate(e.target.value)}
//                                             className='pl-3 pr-2 py-1.5 border-2 border-slate-200 rounded-lg text-xs font-medium text-slate-700 bg-white hover:border-purple-300 focus:border-purple-400 focus:ring-2 focus:ring-purple-100 transition-all outline-none w-full sm:w-auto'
//                                         />
//                                         <div className='absolute inset-0 rounded-lg bg-gradient-to-r from-purple-400/0 to-purple-400/0 group-hover:from-purple-400/5 group-hover:to-transparent pointer-events-none transition-all'></div>
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                     {/* Search & Create */}
//                     <div className='flex flex-col md:flex-row justify-between items-stretch md:items-center gap-3'>
//                         {/* Search Section */}
//                         <div className='flex gap-2 w-full md:w-auto'>
//                             <div className="relative flex-1 md:flex-initial">
//                                 <div className='absolute left-3 top-1/2 -translate-y-1/2'>
//                                     <svg className='w-4 h-4 text-slate-400' fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                                         <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
//                                     </svg>
//                                 </div>
//                                 <input
//                                     type="text"
//                                     value={searchKeyword}
//                                     onChange={(e) => setSearchKeyword(e.target.value)}
//                                     placeholder="Search by Job ID or Title..."
//                                     className="pl-9 pr-10 py-2.5 w-full md:w-72 border-2 border-slate-200 rounded-xl bg-white text-slate-700 text-sm font-medium placeholder-slate-400 hover:border-secondary-300 focus:border-secondary-500 focus:ring-2 focus:ring-secondary-100 transition-all outline-none shadow-sm"
//                                 />

//                                 {searchKeyword && (
//                                     <button
//                                         type="button"
//                                         onClick={handleClearSearch}
//                                         className="absolute right-3 top-1/2 -translate-y-1/2 text-slate-400 hover:text-red-500 font-bold transition-colors duration-200 text-lg"
//                                         title="Clear search"
//                                     >
//                                         ✕
//                                     </button>
//                                 )}
//                             </div>
//                             <button
//                                 onClick={handleSearch}
//                                 className="px-5 py-2.5 bg-gradient-to-r from-secondary-500 to-secondary-600 hover:from-secondary-600 hover:to-secondary-700 text-white rounded-xl font-bold text-sm shadow-md hover:shadow-lg transform hover:scale-105 transition-all duration-200 active:scale-95 whitespace-nowrap"
//                             >
//                                 Search
//                             </button>
//                             <button
//                                 onClick={handleClearSearch}
//                                 className="px-5 py-2.5 bg-gradient-to-r from-red-500 to-red-600 hover:from-red-600 hover:to-red-700 text-white rounded-xl font-bold text-sm shadow-md hover:shadow-lg transform hover:scale-105 transition-all duration-200 active:scale-95 whitespace-nowrap"
//                             >
//                                 Clear
//                             </button>
//                         </div>
//                         {/* Create Job Button */}
//                         {
//                             !['superadmin', 'helpdesk', 'recruiter'].includes(currentUser?.role) &&
//                             <button
//                                 onClick={() => navigate('/create-job')}
//                                 className='px-6 py-2.5 bg-gradient-to-r from-emerald-500 to-teal-600 hover:from-emerald-600 hover:to-teal-700 text-white font-bold text-sm rounded-xl shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-200 active:scale-95 flex items-center justify-center gap-2 w-full md:w-auto'
//                             >
//                                 <svg className='w-5 h-5' fill="currentColor" viewBox="0 0 20 20">
//                                     <path fillRule="evenodd" d="M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z" clipRule="evenodd" />
//                                 </svg>
//                                 Create Job
//                             </button>
//                         }
//                     </div>
//                 </div>
//             </div>

//             {/* Scrollable Table */}
//             <div className="overflow-x-auto bg-white rounded-xl shadow-md">
//                 <div className="">
//                     <table className="min-w-full border-collapse">
//                         <thead className="bg-secondary-700 text-secondary-400 sticky top-0 z-10">
//                             <tr>
//                                 <th className="p-3 whitespace-nowrap border">S.No</th>
//                                 <th className="p-3 whitespace-nowrap border">Job ID</th>
//                                 <th className="p-3 whitespace-nowrap border">Title</th>
//                                 <th className="p-3 whitespace-nowrap border">Client</th>
//                                 <th className="p-3 whitespace-nowrap border">SPOC</th>
//                                 <th className="p-3 whitespace-nowrap border">Job Status</th>
//                                 <th className="p-3 whitespace-nowrap border">Created At</th>

//                                 <th className="p-3 whitespace-nowrap border">Recent Reassigned At</th>
//                                 <th className="p-3 whitespace-nowrap border">Actions</th>
//                             </tr>
//                         </thead>
//                         <tbody>
//                             {displayJobs?.length > 0 ? displayJobs.map((job, idx) => (
//                                 <tr
//                                     key={job._id}
//                                     className="hover:bg-blue-50 transition border-b border-slate-100"
//                                 >
//                                     <td className="p-3 text-center whitespace-nowrap border">{idx + 1}</td>
//                                     <td
//                                         className="p-3  text-primary-500 text-center cursor-pointer font-medium whitespace-nowrap border"
//                                         onClick={() => navigate(`/view-jobs/${job._id}?page=${currentPage}&search=${searchKeyword}`)}
//                                     >
//                                         {job.internalJobId || '-'}
//                                     </td>
//                                     <td className="p-3 whitespace-nowrap border text-center">{renderCapitalize(job.title || '-')}</td>
//                                     <td className="p-3 whitespace-nowrap border text-center">{renderCapitalize(job.client?.name || '-')}</td>
//                                     <td className="p-3 whitespace-nowrap border text-center">{renderCapitalize(job.spoc?.name || '-')}</td>
//                                     <td className="p-3 whitespace-nowrap border text-center">{job.jobStatus || '-'}</td>
//                                     <td className="p-3 md:table-cell hidden whitespace-nowrap border text-center">
//                                         {job.createdAt ? new Date(job.createdAt).toLocaleString("en-GB") : '-'}
//                                     </td>
//                                     <td className="p-3 md:table-cell hidden whitespace-nowrap border text-center">

//                                         {job?.updatedJobAt?.at(-1)?.updatedDate ? new Date(job?.updatedJobAt.at(-1).updatedDate).toLocaleString("en-GB") : '-'}
//                                         <p className='text-sm font-semibold'>{job?.updatedJobAt?.at(-1)?.name ? job?.updatedJobAt?.at(-1)?.name : '-'}</p>
//                                     </td>
//                                     <td className="p-3 flex gap-3 whitespace-nowrap justify-center">
//                                         <FaEye
//                                             className="text-secondary-400 text-lg cursor-pointer"
//                                             title="View Job"
//                                             onClick={() => navigate(`/view-jobs/${job._id}?page=${currentPage}&search=${searchKeyword}`)}
//                                         />
//                                         {getAccess(job) && <FaRegEdit
//                                             className="text-lg text-primary-500 cursor-pointer"
//                                             title="Edit Job"
//                                             onClick={() => navigate(`/update-job/${job._id}?page=${currentPage}&search=${searchKeyword}`)}
//                                         />}
//                                         {['admin'].includes(currentUser?.role) && (
//                                             <MdOutlineDeleteOutline
//                                                 className="text-lg text-red-500 cursor-pointer"
//                                                 title="Delete Job"
//                                                 onClick={() => handleDelete(job._id)}
//                                             />
//                                         )}
//                                         <HiUserAdd
//                                             className="text-xl text-primary-500 cursor-pointer"
//                                             title="Add Candidate(s)"
//                                             onClick={() => navigate(`/list-candidates?job=${job._id}&page=${currentPage}`)}
//                                         />

//                                         <IoPeopleSharp
//                                             className="text-xl text-primary-500 cursor-pointer"
//                                             title="Existing/ Added Candidates"
//                                             onClick={() => {
//                                                 localStorage.setItem('currentPage', currentPage);
//                                                 navigate(`/profile-action?jobId=${job._id}&page=${currentPage}`)
//                                             }}
//                                         />

//                                         <input type='checkbox' checked={job.isReassign} disabled={job.isReassign}
//                                             onChange={(e) => handleReassign(job._id, job.jobId, e.target.checked, e)} />Repost
//                                     </td>
//                                 </tr>
//                             )) : <tr><td colSpan="9" className="text-center p-4">No jobs found</td></tr>}

//                         </tbody>
//                     </table>
//                 </div>
//             </div>

//             {/* Pagination */}
//             {/* <Pagination setAllJobs={setAllJobs} mode="job" /> */}

//             <div className="mt-6 bg-gradient-to-br from-white to-slate-50/50 rounded-2xl shadow-lg border border-slate-200/60 p-5">
//                 <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
//                     {/* Records per page */}
//                     <div className="flex items-center gap-3">
//                         <label htmlFor="recordsPerPage" className="text-sm font-semibold text-slate-700 whitespace-nowrap">
//                             Records per page:
//                         </label>
//                         <select
//                             id="recordsPerPage"
//                             value={rowsPerPage}
//                             onChange={(e) => setRowsPerPage(parseInt(e.target.value, 10))}
//                             className="px-3 py-1 border-[1px] border-secondary-100 rounded-lg bg-white text-slate-700 font-semibold text-sm cursor-pointer hover:border-secondary-400 focus:border-secondary-500 focus:ring-[1px] focus:ring-secondary-100 transition-all outline-none shadow-sm"
//                         >
//                             {[10, 20, 25, 50, 75, 100].map((n) => (
//                                 <option key={n} value={n} className="py-2">
//                                     {n}
//                                 </option>
//                             ))}
//                         </select>
//                     </div>

//                     {/* Page navigation */}
//                     <div className="flex items-center gap-4">
//                         <button
//                             className={`flex items-center justify-center w-10 h-10 rounded-xl transition-all duration-200 ${currentPage === 1
//                                 ? "bg-slate-100 text-slate-400 cursor-not-allowed"
//                                 : "bg-gradient-to-r from-secondary-500 to-secondary-600 text-white hover:from-secondary-600 hover:to-secondary-700 shadow-md hover:shadow-lg transform hover:scale-105 active:scale-95"
//                                 }`}
//                             onClick={() => handlePagination("prev")}
//                             disabled={currentPage === 1}
//                         >
//                             <span className="material-symbols-outlined text-2xl">chevron_left</span>
//                         </button>

//                         <div className="px-5 py-2 bg-gradient-to-r from-secondary-700 to-purple-200 border-[1px] border-secondary-100 rounded-lg">
//                             <span className="text-sm font-bold text-slate-700">
//                                 Page <span className="text-secondary-600">{currentPage}</span> of <span className="text-secondary-600">{totalPage || 0}</span>
//                             </span>
//                         </div>

//                         <button
//                             className={`flex items-center justify-center w-10 h-10 rounded-xl transition-all duration-200 ${currentPage === totalPage
//                                 ? "bg-slate-100 text-slate-400 cursor-not-allowed"
//                                 : "bg-gradient-to-r from-secondary-500 to-secondary-600 text-white hover:from-secondary-600 hover:to-secondary-700 shadow-md hover:shadow-lg transform hover:scale-105 active:scale-95"
//                                 }`}
//                             onClick={() => handlePagination("next")}
//                             disabled={currentPage === totalPage}
//                         >
//                             <span className="material-symbols-outlined text-2xl">chevron_right</span>
//                         </button>
//                     </div>

//                     {/* Total count */}
//                     <div className="flex items-center gap-2 px-4 py-2 bg-gradient-to-r from-green-50 to-emerald-50 border-2 border-green-200 rounded-lg">
//                         <span className="text-sm font-semibold text-slate-600">Total Jobs:</span>

//                         <span className="text-sm font-bold text-green-600">{total || 0}</span>
//                     </div>
//                 </div>

//             </div>
//         </div>
//     );
// };














import React, { useContext, useEffect, useRef, useState } from 'react';
import { DContext } from '../../context/Datacontext';
import { fetchJob } from '../services/fetchJob';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { FaRegEdit } from "react-icons/fa";
import { MdOutlineDeleteOutline } from "react-icons/md";
import { FaEye } from "react-icons/fa";
// import Pagination from './Pagination';
import { reassignJob, updateJob } from '../services/updateJob';
import { HiUserAdd } from "react-icons/hi";
import { IoPeopleSharp } from "react-icons/io5";
import Loading from './Loading';
import { renderCapitalize } from '../../utils/renderCapitalize';
import { TiWarningOutline } from "react-icons/ti";

export const JobList = () => {
    const { BeURL, showAlert, currentUser } = useContext(DContext);
    const [allJobs, setAllJobs] = useState([]);
    const [filteredJobs, setFilteredJobs] = useState([]);
    const [loading, setLoading] = useState(true);
    const [searchActive, setSearchActive] = useState(false);
    const [dateFilterActive, setDateFilterActive] = useState(false);
    const [triggerReassign, setTriggerReassign] = useState(false)


    // Duration and date filters
    const [activeIndex, setActiveIndex] = useState('All')
    const [fromDate, setFromDate] = useState('')
    const [toDate, setToDate] = useState('')

    // Same Pagination after click the CTA Buttons
    const [searchParams, setSearchParams] = useSearchParams();
    const [currentPage, setCurrentPage] = useState(
        Number(searchParams.get("page")) || 1
    );
    // const [searchKeyword, setSearchKeyword] = useState(searchParams.get("search") || "");
    const [searchKeyword, setSearchKeyword] = useState({
        jobId: searchParams.get("jobId") || "",
        title: searchParams.get("title") || "",
        client: searchParams.get("client") || "",
        spoc: searchParams.get("spoc") || ""

    })


    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [totalPage, setTotalPage] = useState(0);
    const [total, setTotal] = useState(0);
    // const [perPageTotal, setPerPageTotal] = useState(0)

    const [filters, setFilters] = useState({
        jobId: "",
        title: "",
        client: "",
        spoc: ""
    });

    const apiRef = useRef()

    const filterButton = [
        { label: 'All', title: 'All' },
        { label: 'Today', title: 'Today' },
        { label: 'YesterDay', title: 'YesterDay' },
        { label: '1W', title: 'This Week' },
        { label: '1M', title: 'This Month' },
        { label: '3M', title: 'Last 3-Month' },
        { label: '6M', title: 'Last 6-Month' },
        { label: '1Y', title: 'This Year' }
    ]

    const navigate = useNavigate();

    const getJobs = async () => {
        if (apiRef.current) return;
        apiRef.current = true;
        setLoading(true);


        try {
            await fetchJob(BeURL, setAllJobs, showAlert, currentPage, rowsPerPage, setTotal, setTotalPage, activeIndex, fromDate, toDate, searchKeyword
            );
        } catch (err) {
            console.error("Error fetching jobs:", err);
        } finally {
            apiRef.current = false;
            setLoading(false);
        }
    };


    useEffect(() => {
        const page = Number(searchParams.get("page")) || 1;
        setCurrentPage(page);
    }, [searchParams]);


    // filter button date range clear
    useEffect(() => {
        if (fromDate || toDate) {
            setActiveIndex("");
        }
    }, [fromDate, toDate]);

    const handleRequirement = (label) => {
        setFromDate('')
        setToDate('')
        setActiveIndex(label)
    }

    const handleDelete = (id) => {
        if (window.confirm("Are you sure you want to delete this job?")) {
            updateJob(BeURL, null, showAlert, null, id, { access: 'delete' });
        }
    };


    const handlePagination = (dir) => {

        let newPage = currentPage;

        if (dir === "prev" && currentPage > 1) {
            newPage = currentPage - 1;
        }

        if (dir === "next" && currentPage < totalPage) {
            newPage = currentPage + 1;
        }

        setCurrentPage(newPage);
        setSearchParams({
            page: newPage,
            jobId: searchKeyword.jobId || "",
            title: searchKeyword.title || "",
            client: searchKeyword.client || "",
            spoc: searchKeyword.spoc || "",
        });
    };

    useEffect(() => {
        if (dateFilterActive) return
        getJobs();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [BeURL, currentPage, rowsPerPage, activeIndex, triggerReassign, searchActive, dateFilterActive]);


    useEffect(() => {
        setSearchKeyword({
            jobId: searchParams.get("jobId") || "",
            title: searchParams.get("title") || "",
            client: searchParams.get("client") || "",
            spoc: searchParams.get("spoc") || "",
        });
    }, [searchParams]);


    const handleSearch = () => {
        setSearchParams({
            // search: searchKeyword,
            jobId: searchKeyword.jobId || "",
            title: searchKeyword.title || "",
            client: searchKeyword.client || "",
            spoc: searchKeyword.spoc || ""
        });

        setCurrentPage(1);
        setSearchActive(true)
        // getJobs(); 
    };

    const handleClearSearch = () => {
        setSearchKeyword({
            jobId: "",
            title: "",
            client: "",
            spoc: ""
        });
        setSearchActive(false)
        setFilteredJobs([]);
        setActiveIndex('All');
        setFromDate('');
        setToDate('');
        setCurrentPage(1);
        setDateFilterActive(false)
        setSearchParams({ page: 1 }); // search param remove
        // setTriggerSearch(prev => !prev);
    };

    // const displayJobs = filteredJobs.length > 0 ? filteredJobs : allJobs;
    const displayJobs = allJobs

    // Access control for Edit button
    const getAccess = (job) => {
        if (job.primaryRecruiter?.email === currentUser?.email) return true;
        if (job.reportingTeamLead?.email === currentUser?.email) return true;
        if (job.reportingManager?.email === currentUser?.email) return true;
        if (['admin'].includes(currentUser?.role)) return true;
        return false;
    }


    const handleColumnFilter = (key, value) => {
        const updatedFilters = { ...searchKeyword, [key]: value };
        setSearchKeyword(updatedFilters);

        //store in URL


        // applyFilters(updatedFilters);
    };

    const handleEnterSearch = (e) => {
        if (e.key === "Enter") {
            handleSearch();
        }
    }

    console.log("Srach keywords::", searchKeyword)


    //  handle for Job reassign
    const handleReassign = async (jobObjId, jobId, isChecked, event) => {
        const isConfirmed = window.confirm("Are you sure you want to reassign this job?");

        if (!isConfirmed) {
            event.target.checked = !isChecked;
            return;
        }
        setTriggerReassign(true)
        const payload = {
            jobId: jobId,
            isreassign: isChecked
        };

        await reassignJob(BeURL, showAlert, jobObjId, payload);
    };

    if (loading) return <Loading />;

    return (
        <div className='min-h-[80vh] space-y-4 mt-3 px-4 md:px-10'>
            <h2 className="text-2xl font-semibold mb-4 text-gray-800 text-center">All Jobs</h2>

            <div className='bg-gradient-to-br from-white to-slate-50/50 rounded-2xl shadow-lg border border-slate-200/60 p-4 mb-6'>
                <div className='flex flex-col gap-3'>
                    {/* Time Filter Buttons & Date Range */}
                    <div className="space-y-3 flex flex-col md:flex-row md:justify-between md:items-center flex-wrap ">
                        {/* Quick Filter Buttons */}
                        <div className='flex items-center gap-2 flex-wrap'>
                            <div className='flex items-center gap-1.5'>
                                {/* <div className='w-1 h-5 bg-gradient-to-b from-secondary-400 to-secondary-600 rounded-full'></div> */}
                                <h3 className='text-xs font-bold text-slate-700 uppercase tracking-wide'>Quick Filters</h3>
                            </div>
                            <div className="flex gap-2 flex-wrap">
                                {filterButton.map((btn, i) => (
                                    <button
                                        key={i}
                                        title={btn.title}
                                        className={`relative px-3 py-1.5 font-semibold text-xs rounded-lg transition-all duration-300 transform hover:scale-105 hover:shadow-md
                                     ${activeIndex === btn.label
                                                ? "bg-gradient-to-r from-secondary-400 to-secondary-600 text-white shadow-lg shadow-secondary-200/50 scale-105"
                                                : "bg-white text-secondary-500 border-[1px] border-secondary-100 hover:border-secondary-400 hover:bg-secondary-700"
                                            }
                                        ${activeIndex === btn.label ? 'ring-[1px] ring-secondary-200 ring-offset-1' : ''}`}
                                        onClick={() => handleRequirement(btn.label)}
                                    >
                                        {activeIndex === btn.label && (
                                            <span className="absolute -top-0.5 -right-0.5 flex h-2 w-2">
                                                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-white opacity-75"></span>
                                                <span className="relative inline-flex rounded-full h-2 w-2 bg-white"></span>
                                            </span>
                                        )}
                                        {btn.label}
                                    </button>
                                ))}
                            </div>
                        </div>

                        {/* Create Job Button */}
                        {
                            !['superadmin', 'helpdesk', 'recruiter'].includes(currentUser?.role) &&
                            <button
                                onClick={() => navigate('/create-job')}
                                className='px-6 py-2.5 bg-gradient-to-r from-emerald-500 to-teal-600 hover:from-emerald-600 hover:to-teal-700 text-white font-bold text-sm rounded-xl shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-200 active:scale-95 flex items-center justify-center gap-2 w-full md:w-auto'
                            >
                                <svg className='w-5 h-5' fill="currentColor" viewBox="0 0 20 20">
                                    <path fillRule="evenodd" d="M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z" clipRule="evenodd" />
                                </svg>
                                Create Job
                            </button>
                        }


                    </div>
                    {/* Search & Create */}
                    <div className='flex flex-col md:flex-row justify-between items-stretch md:items-center gap-3'>
                        {/* Search Section */}
                        {/* <div className='flex gap-2 w-full md:w-auto'>
                            <div className="relative flex-1 md:flex-initial">
                                <div className='absolute left-3 top-1/2 -translate-y-1/2'>
                                    <svg className='w-4 h-4 text-slate-400' fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                                    </svg>
                                </div>
                                <input
                                    type="text"
                                    value={searchKeyword}
                                    onChange={(e) => setSearchKeyword(e.target.value)}
                                    placeholder="Search by Job ID or Title..."
                                    className="pl-9 pr-10 py-2.5 w-full md:w-72 border-2 border-slate-200 rounded-xl bg-white text-slate-700 text-sm font-medium placeholder-slate-400 hover:border-secondary-300 focus:border-secondary-500 focus:ring-2 focus:ring-secondary-100 transition-all outline-none shadow-sm"
                                />

                                {searchKeyword && (
                                    <button
                                        type="button"
                                        // onMouseDown={(e) => e.preventDefault()}
                                        onClick={handleClearSearch}
                                        className="absolute right-3 top-1/2 -translate-y-1/2 text-slate-400 hover:text-red-500 font-bold transition-colors duration-200 text-lg"
                                        title="Clear search"
                                    >
                                        ✕
                                    </button>
                                )}
                            </div>
                            <button
                                onClick={handleSearch}
                                className="px-5 py-2.5 bg-gradient-to-r from-secondary-500 to-secondary-600 hover:from-secondary-600 hover:to-secondary-700 text-white rounded-xl font-bold text-sm shadow-md hover:shadow-lg transform hover:scale-105 transition-all duration-200 active:scale-95 whitespace-nowrap"
                            >
                                Search
                            </button>

                        </div> */}

                        {/* Date Range Picker */}
                        <div className='flex items-center gap-2 flex-wrap'>
                            <div className='flex items-center gap-1.5'>
                                {/* <div className='w-1 h-5 bg-gradient-to-b from-purple-400 to-purple-600 rounded-full'></div> */}
                                <h3 className='text-xs font-bold text-slate-700 uppercase tracking-wide'>Custom Range</h3>
                            </div>
                            <div className='flex gap-2 items-center flex-wrap'>
                                <div className='group relative'>
                                    <label className='text-xs font-semibold text-slate-600 mb-0.5 block'>From Date</label>
                                    <div className='relative'>
                                        <input
                                            type='date'
                                            value={fromDate}
                                            onChange={(e) => {
                                                setFromDate(e.target.value)
                                                setDateFilterActive(true)
                                            }}
                                            className='pl-3 pr-2 py-1.5 border-2 border-slate-200 rounded-lg text-xs font-medium text-slate-700 bg-white hover:border-purple-300 focus:border-purple-400 focus:ring-2 focus:ring-purple-100 transition-all outline-none w-full sm:w-auto'
                                        />
                                        <div className='absolute inset-0 rounded-lg bg-gradient-to-r from-purple-400/0 to-purple-400/0 group-hover:from-purple-400/5 group-hover:to-transparent pointer-events-none transition-all'></div>
                                    </div>
                                </div>
                                <div className='hidden sm:flex items-center pt-5'>
                                    <svg className='w-5 h-5 text-slate-400' fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
                                    </svg>
                                </div>
                                <div className='group relative'>
                                    <label className='text-xs font-semibold text-slate-600 mb-0.5 block'>To Date</label>
                                    <div className='relative'>
                                        <input
                                            type='date'
                                            value={toDate}
                                            onChange={(e) => {
                                                setToDate(e.target.value)
                                                setDateFilterActive(true)
                                            }}
                                            className='pl-3 pr-2 py-1.5 border-2 border-slate-200 rounded-lg text-xs font-medium text-slate-700 bg-white hover:border-purple-300 focus:border-purple-400 focus:ring-2 focus:ring-purple-100 transition-all outline-none w-full sm:w-auto'
                                        />
                                        <div className='absolute inset-0 rounded-lg bg-gradient-to-r from-purple-400/0 to-purple-400/0 group-hover:from-purple-400/5 group-hover:to-transparent pointer-events-none transition-all'></div>
                                    </div>
                                </div>

                                <div className='group relative'>
                                    <button
                                        onClick={() => setDateFilterActive(false)}
                                        className="px-5 py-2.5 mt-4  hover:bg-gradient-to-r from-secondary-500 hover:to-secondary-600 text-secondary-400 hover:text-white rounded-xl  font-bold text-sm shadow-md shadow-secondary-50 hover:shadow-lg transform hover:scale-105 transition-all duration-200 active:scale-95 whitespace-nowrap"
                                    >
                                        Filter
                                    </button>
                                </div>
                            </div>
                        </div>

                        <div className='md:mt-4'>
                            <button
                                onClick={handleClearSearch}
                                className="px-5 py-2.5 bg-gradient-to-r from-red-500 to-red-600 hover:from-red-600 hover:to-red-700 text-white rounded-xl font-bold text-sm shadow-md hover:shadow-lg transform hover:scale-105 transition-all duration-200 active:scale-95 whitespace-nowrap"
                            >
                                Clear
                            </button>
                        </div>


                    </div>
                </div>
            </div>

            {/* Scrollable Table */}
            <div className="overflow-x-auto bg-white rounded-xl shadow-md">
                <div className="">
                    <table className="min-w-full border-collapse">
                        <thead className="sticky top-0 z-10 bg-white shadow-sm">
                            <tr className="text-secondary-400 bg-secondary-700  text-sm font-semibold">
                                <th className="p-3 whitespace-nowrap ">S.No</th>
                                <th className="p-3 whitespace-nowrap w-full min-w-[150px]">Job ID</th>
                                <th className="p-3 whitespace-nowrap ">Title</th>
                                <th className="p-3 whitespace-nowrap ">Client</th>
                                <th className="p-3 whitespace-nowrap w-full min-w-[150px]">SPOC</th>
                                <th className="p-3 whitespace-nowrap ">Job Status</th>
                                <th className="p-3 whitespace-nowrap ">Created At</th>

                                <th className="p-3 whitespace-nowrap ">Recent Reassigned At</th>
                                <th className="p-3 whitespace-nowrap ">Actions</th>
                            </tr>
                            <tr className="bg-slate-50 border-b">
                                <th className="p-1 whitespace-nowrap text-primary-300"></th>
                                <th className="p-1 ">
                                    {searchKeyword.jobId && <span className="p-1 px-2 bg-yellow-200 text-xs text-yellow-700 rounded-lg m-1 flex w-44 gap-1 items-center"><TiWarningOutline /> Hit the Enter button</span>}

                                    <input
                                        type="text"
                                        placeholder="Search Job ID..."
                                        value={searchKeyword.jobId}

                                        onChange={(e) => handleColumnFilter("jobId", e.target.value)}
                                        onKeyDown={(e) => handleEnterSearch(e)}
                                        className="w-full  px-3 py-3 text-sm font-medium 
        text-slate-700 bg-white border border-slate-300 rounded-lg shadow-sm
        placeholder:text-slate-400
        hover:border-secondary-400 
        focus:border-secondary-500 focus:ring-2 focus:ring-secondary-100 
        outline-none transition-all"
                                    />
                                </th>
                                <th className="p-1 ">
                                    {searchKeyword.title && <span className="p-1 px-2 bg-yellow-200 text-xs text-yellow-700 rounded-lg m-1 flex w-44 gap-1 items-center"><TiWarningOutline /> Hit the Enter button</span>}

                                    <input
                                        type="text"
                                        placeholder="Search Title..."
                                        value={searchKeyword.title}
                                        onChange={(e) => handleColumnFilter("title", e.target.value)}
                                        onKeyDown={(e) => handleEnterSearch(e)}
                                        className="w-full  px-3 py-3 text-sm font-medium 
                                   text-slate-700 bg-white border border-slate-300 rounded-lg shadow-sm
        placeholder:text-slate-400
        hover:border-secondary-400 
        focus:border-secondary-500 focus:ring-2 focus:ring-secondary-100 
        outline-none transition-all"
                                    />
                                </th>
                                <th className="p-1 ">
                                    {searchKeyword.client && <span className="p-1 px-2 bg-yellow-200 text-xs text-yellow-700 rounded-lg m-1 flex w-44 gap-1 items-center"><TiWarningOutline /> Hit the Enter button</span>}

                                    <input
                                        type="text"
                                        placeholder="Search Client..."
                                        value={searchKeyword.client}
                                        onChange={(e) => handleColumnFilter("client", e.target.value)}
                                        onKeyDown={(e) => handleEnterSearch(e)}
                                        className="w-full px-3 py-3 text-sm font-medium 
                                   text-slate-700 bg-white border border-slate-300 rounded-lg shadow-sm
        placeholder:text-slate-400
        hover:border-secondary-400 
        focus:border-secondary-500 focus:ring-2 focus:ring-secondary-100 
        outline-none transition-all"
                                    />
                                </th>
                                <th className="p-1 ">
                                    {searchKeyword.spoc && <span className="p-1 px-2 bg-yellow-200 text-xs text-yellow-700 rounded-lg m-1 flex w-44 gap-1 items-center"><TiWarningOutline /> Hit the Enter button</span>}

                                    <input
                                        type="text"
                                        placeholder="Search SPOC..."
                                        value={searchKeyword.spoc}
                                        onChange={(e) => handleColumnFilter("spoc", e.target.value)}
                                        onKeyDown={(e) => handleEnterSearch(e)}
                                        className="w-full  px-3 py-3 text-sm font-medium 
                                   text-slate-700 bg-white border border-slate-300 rounded-lg shadow-sm
        placeholder:text-slate-400
        hover:border-secondary-400 
        focus:border-secondary-500 focus:ring-2 focus:ring-secondary-100 
        outline-none transition-all"
                                    />
                                </th>
                                <th className="p-1 whitespace-nowrap "></th>
                                <th className="p-1 whitespace-nowrap ">
                                    {/* <div className='flex gap-2 items-center'>
                                        <div className='group relative'>
                                            <label className='text-xs font-semibold text-slate-600 mb-0.5 block'>From</label>
                                            <div className='relative'>
                                                <input
                                                    type='date'
                                                    value={fromDate}
                                                    onChange={(e) => setFromDate(e.target.value)}
                                                    className='py-1.5 border-2 border-slate-200 rounded-lg text-xs font-medium text-slate-700 bg-white hover:border-purple-300 focus:border-purple-400 focus:ring-2 focus:ring-purple-100 transition-all outline-none w-full sm:w-auto'
                                                />
                                                <div className='absolute inset-0 rounded-lg bg-gradient-to-r from-purple-400/0 to-purple-400/0 group-hover:from-purple-400/5 group-hover:to-transparent pointer-events-none transition-all'></div>
                                            </div>
                                        </div>
                                        <div className='group relative'>
                                            <label className='text-xs font-semibold text-slate-600 mb-0.5 block'>To</label>
                                            <div className='relative'>
                                                <input
                                                    type='date'
                                                    value={toDate}
                                                    onChange={(e) => setToDate(e.target.value)}
                                                    className='pl-3 pr-2 py-1.5 border-2 border-slate-200 rounded-lg text-xs font-medium text-slate-700 bg-white hover:border-purple-300 focus:border-purple-400 focus:ring-2 focus:ring-purple-100 transition-all outline-none w-full sm:w-auto'
                                                />
                                                <div className='absolute inset-0 rounded-lg bg-gradient-to-r from-purple-400/0 to-purple-400/0 group-hover:from-purple-400/5 group-hover:to-transparent pointer-events-none transition-all'></div>
                                            </div>
                                        </div>
                                    </div> */}
                                </th>

                                <th className="p-3 whitespace-nowrap "></th>
                                <th className="p-3 whitespace-nowrap "></th>
                            </tr>
                        </thead>
                        <tbody>
                            {displayJobs?.length > 0 ? displayJobs.map((job, idx) => (
                                <tr
                                    key={job._id}
                                    className="hover:bg-blue-50 transition border-b border-slate-100"
                                >

                                    <td className="p-3 text-center whitespace-nowrap border">{idx + 1}</td>
                                    <td
                                        className="p-3  text-primary-500 text-center cursor-pointer font-medium whitespace-nowrap border"
                                        onClick={() => navigate(
                                            `/view-jobs/${job._id}?page=${currentPage}
            &jobId=${searchKeyword.jobId}
            &title=${searchKeyword.title}
            &client=${searchKeyword.client}
            &spoc=${searchKeyword.spoc}`
                                        )}
                                    >
                                        {job.internalJobId || '-'}
                                    </td>
                                    <td className="p-3 whitespace-nowrap border text-center">{renderCapitalize(job.title || '-')}</td>
                                    <td className="p-3 whitespace-nowrap border text-center">{renderCapitalize(job.client?.name || '-')}</td>
                                    <td className="p-3 whitespace-nowrap border text-center">{renderCapitalize(job.spoc?.name || '-')}</td>
                                    <td className="p-3 whitespace-nowrap border text-center">{job.jobStatus || '-'}</td>
                                    <td className="p-3 md:table-cell hidden whitespace-nowrap border text-center">
                                        {job.createdAt ? new Date(job.createdAt).toLocaleString("en-GB") : '-'}
                                    </td>
                                    <td className="p-3 md:table-cell hidden whitespace-nowrap border text-center">

                                        {job?.updatedJobAt?.at(-1)?.updatedDate ? new Date(job?.updatedJobAt.at(-1).updatedDate).toLocaleString("en-GB") : '-'}
                                        <p className='text-sm font-semibold'>{job?.updatedJobAt?.at(-1)?.name ? job?.updatedJobAt?.at(-1)?.name : '-'}</p>
                                    </td>
                                    <td className="p-3 flex gap-3 whitespace-nowrap justify-center">
                                        <FaEye
                                            className="text-secondary-400 text-lg cursor-pointer"
                                            title="View Job"
                                            onClick={() =>
                                                navigate(
                                                    `/view-jobs/${job._id}?page=${currentPage}
            &jobId=${searchKeyword.jobId}
            &title=${searchKeyword.title}
            &client=${searchKeyword.client}
            &spoc=${searchKeyword.spoc}`
                                                )
                                            }
                                        />
                                        {getAccess(job) && (
                                            <FaRegEdit
                                                className="text-lg text-primary-500 cursor-pointer"
                                                title="Edit Job"
                                                onClick={() =>
                                                    navigate(
                                                        `/update-job/${job._id}?page=${currentPage}
                &jobId=${searchKeyword.jobId}
                &title=${searchKeyword.title}
                &client=${searchKeyword.client}
                &spoc=${searchKeyword.spoc}`
                                                    )
                                                }
                                            />
                                        )}
                                        {['admin'].includes(currentUser?.role) && (
                                            <MdOutlineDeleteOutline
                                                className="text-lg text-red-500 cursor-pointer"
                                                title="Delete Job"
                                                onClick={() => handleDelete(job._id)}
                                            />
                                        )}
                                        <HiUserAdd
                                            className="text-xl text-primary-500 cursor-pointer"
                                            title="Add Candidate(s)"
                                            onClick={() => navigate(`/list-candidates?job=${job._id}&page=${currentPage}&jobId=${searchKeyword.jobId}
                &title=${searchKeyword.title}
                &client=${searchKeyword.client}
                &spoc=${searchKeyword.spoc}`)}
                                        />

                                        <IoPeopleSharp
                                            className="text-xl text-primary-500 cursor-pointer"
                                            title="Existing/ Added Candidates"
                                            onClick={() => {
                                                localStorage.setItem('currentPage', currentPage);
                                                navigate(`/profile-action?jobId=${job._id}&page=${currentPage}&jobId=${searchKeyword.jobId}
                &title=${searchKeyword.title}
                &client=${searchKeyword.client}
                &spoc=${searchKeyword.spoc}`)
                                            }}
                                        />

                                        <input type='checkbox' checked={job.isReassign} disabled={job.isReassign}
                                            onChange={(e) => handleReassign(job._id, job.jobId, e.target.checked, e)} />Repost
                                    </td>
                                </tr>
                            )) : <tr><td colSpan="9" className="text-center p-4">No jobs found</td></tr>}

                        </tbody>
                    </table>
                </div>
            </div>

            {/* Pagination */}
            {/* <Pagination setAllJobs={setAllJobs} mode="job" /> */}

            <div className="mt-6 bg-gradient-to-br from-white to-slate-50/50 rounded-2xl shadow-lg border border-slate-200/60 p-5">
                <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
                    {/* Records per page */}
                    <div className="flex items-center gap-3">
                        <label htmlFor="recordsPerPage" className="text-sm font-semibold text-slate-700 whitespace-nowrap">
                            Records per page:
                        </label>
                        <select
                            id="recordsPerPage"
                            value={rowsPerPage}
                            onChange={(e) => setRowsPerPage(parseInt(e.target.value, 10))}
                            className="px-3 py-1 border-[1px] border-secondary-100 rounded-lg bg-white text-slate-700 font-semibold text-sm cursor-pointer hover:border-secondary-400 focus:border-secondary-500 focus:ring-[1px] focus:ring-secondary-100 transition-all outline-none shadow-sm"
                        >
                            {[10, 20, 25, 50, 75, 100].map((n) => (
                                <option key={n} value={n} className="py-2">
                                    {n}
                                </option>
                            ))}
                        </select>
                    </div>

                    {/* Page navigation */}
                    <div className="flex items-center gap-4">
                        <button
                            className={`flex items-center justify-center w-10 h-10 rounded-xl transition-all duration-200 ${currentPage === 1
                                ? "bg-slate-100 text-slate-400 cursor-not-allowed"
                                : "bg-gradient-to-r from-secondary-500 to-secondary-600 text-white hover:from-secondary-600 hover:to-secondary-700 shadow-md hover:shadow-lg transform hover:scale-105 active:scale-95"
                                }`}
                            onClick={() => handlePagination("prev")}
                            disabled={currentPage === 1}
                        >
                            <span className="material-symbols-outlined text-2xl">chevron_left</span>
                        </button>

                        <div className="px-5 py-2 bg-gradient-to-r from-secondary-700 to-purple-200 border-[1px] border-secondary-100 rounded-lg">
                            <span className="text-sm font-bold text-slate-700">
                                Page <span className="text-secondary-600">{currentPage}</span> of <span className="text-secondary-600">{totalPage || 0}</span>
                            </span>
                        </div>

                        <button
                            className={`flex items-center justify-center w-10 h-10 rounded-xl transition-all duration-200 ${currentPage === totalPage
                                ? "bg-slate-100 text-slate-400 cursor-not-allowed"
                                : "bg-gradient-to-r from-secondary-500 to-secondary-600 text-white hover:from-secondary-600 hover:to-secondary-700 shadow-md hover:shadow-lg transform hover:scale-105 active:scale-95"
                                }`}
                            onClick={() => handlePagination("next")}
                            disabled={currentPage === totalPage}
                        >
                            <span className="material-symbols-outlined text-2xl">chevron_right</span>
                        </button>
                    </div>

                    {/* Total count */}
                    <div className="flex items-center gap-2 px-4 py-2 bg-gradient-to-r from-green-50 to-emerald-50 border-2 border-green-200 rounded-lg">
                        <span className="text-sm font-semibold text-slate-600">Total Jobs:</span>

                        <span className="text-sm font-bold text-green-600">{total || 0}</span>
                    </div>
                </div>

            </div>
        </div>
    );
};
